// Whether a keystroke belongs to what the user is typing rather than to the
// map's shortcuts. Form fields are not the only place text gets written: the
// military plan's Text tool edits a `contentEditable` element in place, and
// gating on the tag name alone let ZQSD/WASD pan the map instead of writing —
// « SECTEUR NORD » came out as « ECTEUR NOR » (PP-46).

const FORM_FIELDS = new Set(['INPUT', 'TEXTAREA', 'SELECT'])

export function isTypingTarget(element) {
  if (!element) return false
  if (element.isContentEditable) return true
  return FORM_FIELDS.has(element.tagName)
}
